import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@heroui/react";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { apiRoute, ENUM_PAGEACTION_TYPE, linksUrl } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import { toast } from "react-toastify";
import ConfirmBox from "../../components/ConfirmBox";
import { setDetailParams, setNewEntryMode } from "../../state/shadeSlice";
import { isPending } from "@reduxjs/toolkit";

const ShadeMaster = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);

    const [itemToDelete, setItemToDelete] = useState("")
    const [itemToEdit, setItemToEdit] = useState("")
    const [pageActionType, setPageActionType] = useState("")

    const {
        data: shadeData = [],
        isPending,
        isError,
        mutate: filterData,
    } = usePost({
        url: apiRoute.shade.getshade,
        queryKey: "fetchShadeMaster",
    });

    const funLoadData = () => {
        filterData({
            data: {}
        })
    }
    useEffect(() => {
        funLoadData();
    }, [])
    const sortedShadeData = [...shadeData].sort((a, b) => a.Sh_Ord - b.Sh_Ord);
    const onSuccessDelete = (data) => {
        if (data && data.length > 0) {
            if (data[0].ref == 1) {
                toast.error("Sahde/Color can't be delete as it locked", {
                    position: "top-center",
                    "className": "toast-error",
                })
            }
            else {
                setItemToDelete("")
                funLoadData();
               

            }


        }
    };

    const { mutate: deleteShade } = usePost({
        url: apiRoute.shade.deleteShade,
        queryKey: "deleteShadeMaster",
        onSuccessTasks: onSuccessDelete,
       // successMessage: "Shade deleted successfully!",
    });

    const handleDeleteClick = (Sh_Code) => {
        if (!Sh_Code) {
            toast.error("Error: Shade Code is missing.");
            return;
        }
        else
            setItemToDelete(Sh_Code)
    };

    const handleConfirmBox = (data) => {
        if (data) {
            if (itemToDelete && itemToDelete != null) {
                deleteShade({ data: { Sh_Code: itemToDelete } });
            }
            else if (itemToEdit != "" && itemToEdit != null && Object.keys(itemToEdit).length > 0) {
                dispatch(setDetailParams(itemToEdit));
                dispatch(setNewEntryMode(false))
                navigate(linksUrl.diamondParamater.shade.createShadeMaster);
            }
        }
        else {
            setItemToDelete("")
            setItemToEdit("")
            setPageActionType("")
        }
    };

    const handleAddNew = () => {
        dispatch(setNewEntryMode(true));
        dispatch(setDetailParams([]));
        navigate(linksUrl.diamondParamater.shade.createShadeMaster);
    };
    const exportColumns = [
        { name: "shade Code", uid: "Sh_Code" },
        { name: "shade Name", uid: "Sh_Name" },
        { name: "shade Group", uid: "Sh_Group" },
        { name: "shade Order", uid: "Sh_Ord" },
    ]
    const downloadDataFooter = {
        Sh_Code: "", Sh_Name: "", Sh_Group: "", Sh_Ord: ""
    }
    const columns = [
        { name: "Actions", uid: "actions", align: COLUMN_ALIGN_TYPE.center },
        { name: "shade Code", uid: "Sh_Code", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "shade Name", uid: "Sh_Name", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "shade Group", uid: "Sh_Group", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "shade Order", uid: "Sh_Ord", sortable: true, align: COLUMN_ALIGN_TYPE.center },
    ];

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon icon={faEdit} style={{ color: "#379906" }} />,
            onClick: (row) => {
                setItemToDelete("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
                let obj = {
                    Sh_Code: row.Sh_Code
                };
                setItemToEdit(obj)

            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon icon={faTrash} style={{ color: "#c40c18" }} />,
            onClick: (row) => {
                setItemToEdit("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
                handleDeleteClick(row.Sh_Code);
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
    ];

    if (isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;


    return (
        <div>
            <MainContainer pageName="Shade Master" breadcrumbs={["Diamond Parameter", "Shade Master"]}>
                <div className="text-right mb-4">
                    <Button size="sm" color="primary" startContent={<FontAwesomeIcon icon={faPlus} />} onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={["actions", "Sh_Code", "Sh_Name", "Sh_Group", "Sh_Ord"]}
                    data={sortedShadeData}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    showAdvanceFilter={false}
                    exportColumns={exportColumns}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName="Shade-master-List"
                    id="Sh_Code"

                />
            </MainContainer>

            {(itemToDelete || itemToEdit) && (
                <ConfirmBox
                    handleConfirmBox={handleConfirmBox}
                    actionType={pageActionType}
                />
            )}
        </div>
    );
}
export default ShadeMaster